/* 模块组件 ChenYN 说明 手机号验证码 版本 1.0 传参 canInputPhone Boolean : 非必填 是否显示号码输入框
username String : 非必填 用户名 依赖 /style/2019/h5/css/common.css vue.js 案例
<IdentifyingInput></IdentifyingInput>
*/
<template>
    <div>
        <div class="phone_components tips_wrap pr mb17">
            <i class="register_input_icon_left icon_phone"></i>
            <!-- <b>+86</b> -->
            <Field
                v-if="canInputPhone"
                maxlength="11"
                v-model.trim="phone"
                class="common_ring_btn"
                label
                type="tel"
                placeholder="请输入手机号码"
                autocomplete="off"
                v-on:input="commitMobile"
                @focus="inputFocus('phone')"
                @blur="inputBlur('phone')"
            />
            <Field
                v-else
                maxlength="11"
                v-model="encryptedPhone"
                class="common_ring_btn"
                label
                type="tel"
                autocomplete="off"
                readonly
            />
            <!-- <div class="tips_msg">{{ tipsList.phone }}</div> -->
        </div>

        <div class="pr tips_wrap">
            <i class="register_ver_icon_left icon_verification"></i>
            <Field
                maxlength="6"
                v-model="captcha"
                class="common_ring_btn"
                label
                type="number"
                placeholder="请输入验证码"
                autocomplete="off"
                v-on:input="commitCaptcha"
                @focus="inputFocus('captcha')"
                @blur="inputBlur('captcha')"
            >
                <template #button>
                    <a
                        v-if="second === 60"
                        href="javascript:;"
                        class="cache red"
                        v-on:click="getCaptcha"
                        >发送验证码</a
                    >
                    <p v-else class="cache">{{ second }}S后重试</p>
                </template>
            </Field>
            <div class="tncode" ref="tncodeRef" style="display: none"></div>
            <!-- <div class="tips_msg">{{ tipsList.captcha }}</div> -->
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onUnmounted } from 'vue';
import { Field } from 'vant';
import { useRoute } from "vue-router";
import router from '@/router';
import Util from '@/assets/js/lib/util';
import $TN from '@/assets/js/lib/tn_code.js';

export default defineComponent({
    name: 'IdentifyingInput',
    emits: ['captcha', 'phone'],
    components: { Field, },
    props: {
        canInputPhone: {
            type: Boolean,
            default: true
        },
        username: {
            type: String,
            default: ''
        },
        encryptedPhone: {
            type: String,
        }
    },
    setup(props, context) {
        const state = reactive({
            type: 'text',
            phone: '',
            captcha: '',
            second: 60,
            Util: new Util(),
            setTime: '',
            route: useRoute(),
            tipsList: {
                phone: '',
                captcha: ''
            },
            offset: '',
            token: '',
            point_json: '',
            tncodeRef: '',
            isRefreshCode: false,
        });

        const getCaptcha = async (e) => {
            if(props.canInputPhone){
                if(state.phone == ''){
                    window.Components.toast('请输入手机号码');
                    state.tipsList.phone = '*请输入手机号码';
                    return false;
                }
                if(!state.Util.CSRegular().phone(state.phone)){
                    window.Components.toast('请输入正确手机号');
                    state.tipsList.phone = '*请输入正确手机号';
                    return false;
                }
            }else if(props.username.trim() == ''){
                    window.Components.toast('请输入账号');

                    return false;
            }

            //是否存在账号
            if(state.route.path == '/login'){
                const res = await state.Util.getUserJson('/user/check_username', 'POST', {username: state.phone,verify_type:2}, false);

                if(res.code == 40009){
                    context.emit('hasUser', true);
                }else{
                    // setTimeout(() => {
                    //     window.Components.toast('当前账号不存在，可填入实名信息直接注册');
                    // }, 1000);
                    // state.tipsList.phone = '*用户不存在';
                    context.emit('hasUser', false);
                }
                //请求验证码的事件，方便阅读，抽离成一个方法
                reqCaptcha();
                return;
            }

            // if(state.route.path == '/forget'){
            //     const res = await state.Util.getUserJson('/user/check_username', 'POST', {username: props.username,verify_type:1}, false);

            //     if(res.code == 40009){
            //         // //请求验证码的事件，方便阅读，抽离成一个方法
            //         // reqCaptcha();
            //     }else{
            //         window.Components.toast(res.msg);
            //     }
            //     return;
            // }

            reqCaptcha();
        };
        const reqCaptcha = async() => {
            if(state.token === '' || state.offset === '' || state.point_json === ''){
                $TN.show('',state.tncodeRef);
                return false;
            }

            const param = {
                send_type : 1,
                captcha_data: encodeURIComponent(JSON.stringify({
                    captcha_type: 1,
                    point_json: state.point_json,
                    token: state.token
                }))
            };

            if(state.route.path == '/forget'){
                param.send_type = 2;
                param.username= props.username;
            }else{
                param.mobile= state.phone;
            }

            const res = await state.Util.getUserJson('/v2/user/send_captcha', 'POST', param, false);

            if(res.code == 1){
                window.Components.toast('发送验证码成功');
                state.setTime = setInterval(() => {
                    if (state.second === 0) {
                    state.second = 60;
                    clearInterval(state.setTime);
                    resetTN();
                    } else {
                    state.second -= 1;
                    }
                }, 1000);
            // }else if(res.code == 40001){
            //     window.Components.toast('手机号格式不正确');
            //     state.tipsList.phone = '*请输入正确的手机号码';
            }else {
                window.Components.toast(res.msg);
                resetTN();
            }
        }
        const resetTN = () => {
            $TN.destroyed();
            if(state.isRefreshCode){
                $TN.refresh();
            }
            setTimeout(() => {
                $TN.init();
                state.token = '';
                state.offset = '';
                state.point_json = '';
            }, 100);
        };
        const commitMobile = (e) => {
            context.emit('changeMobile', e.target.value);
        };
        const commitCaptcha = (e) => {
            context.emit('changeCaptcha', e.target.value);
        };
        const inputFocus = (type) => {
            state.tipsList[type] = '';
        };
        const inputBlur = (type) => {
            if(state[type] == '') return false;
            let list = {
                phone: '*请输入正确的手机号码',
                captcha: '*验证码格式错误'
            };
            if(!state.Util.CSRegular()[type](state[type])){
                state.tipsList[type] = list[type];
            }
        };

        onMounted(() => {
            $TN.init();
            $TN.onsuccess(function () {
                state.offset = this._mark_offset;
                state.point_json = this._point_json;
                state.token = this._token;
                state.isRefreshCode = true;
                getCaptcha();
            });
        })

        onUnmounted(()=>{
            $TN.destroyed();
            if(state.isRefreshCode){
                $TN.refresh();
            }
        })

        return {
            getCaptcha,
            commitMobile,
            commitCaptcha,
            inputFocus,
            inputBlur,
            ...toRefs(state),
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "@/assets/less/common/register.less";
</style>
